import { $enum } from "ts-enum-util";

import { MyLensesLensCtaText, MyLensesLensCtaType } from "../../../gql-generated/types";
import { type Option } from "../../../shared/models";
import { filterWebsiteOptions } from "../../filters";
import { LensCtaTextLabelMap, LensCtaTypeLabelMap } from "../../models";

export const options: {
    type: Option<MyLensesLensCtaType>[];
    text: Option<MyLensesLensCtaText>[];
} = {
    type: $enum(MyLensesLensCtaType)
        .getValues()
        .map((value) => ({
            value,
            label: LensCtaTypeLabelMap[value],
        })),
    text: $enum(MyLensesLensCtaText)
        .getValues()
        .filter((value) => value !== MyLensesLensCtaText.CtaTextUnset)
        .map((value) => ({
            value,
            label: LensCtaTextLabelMap[value],
        })),
};

export const websiteTextOptions = filterWebsiteOptions(options.text);
